import { useEffect } from "react";
import CheckoutShell from "./CheckoutShell";
import { useCommerce } from "@/contexts/CommerceContext";


const CheckoutResultPage = ({ cancelled = false }) => {
  const { clearCart, logout } = useCommerce();

  useEffect(() => {
    if (cancelled) return;
    clearCart();
    logout().catch(() => undefined);
  }, [cancelled, clearCart, logout]);

  return (
    <CheckoutShell
      eyebrow={cancelled ? "Checkout cancelled" : "Payment complete"}
      title={cancelled ? "No payment was taken" : "Thank you for your order"}
    >
      <p>
        {cancelled
          ? "Your basket is still saved. You can return whenever you are ready."
          : "Tebex has received the order. Delivery and receipt details will follow the package configuration in Tebex."}
      </p>
    </CheckoutShell>
  );
};

export default CheckoutResultPage;
